import { once } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';

interface UserDragHandlerProps {
  analyticsStore: AnalyticsStore;
  formatContext: AdContext;
}

export class UserDragHandler {
  analyticsStore: AnalyticsStore;
  formatContext: AdContext;

  constructor({ analyticsStore, formatContext }: UserDragHandlerProps) {
    this.analyticsStore = analyticsStore;
    this.formatContext = formatContext;
    this.handle = once(this.handle.bind(this));
  }

  handle() {
    const formatContext = this.formatContext;

    if (
      formatContext.adUnitType === 'overlay_thumbnail' &&
      formatContext.isAdUnitDraggable
    ) {
      this.analyticsStore.sendCreativeTrack('dragged');
    }
  }
}
